import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface HideIconProps {
  mainColor?: string;
  height?: string;
  width?: string;
  style?: React.CSSProperties;
}

export default function HideIcon({
  mainColor = RoutalPalette.primary40,
  height = `18px`,
  width = `10px`,
  style = {},
}: HideIconProps) {
  return (
    <SvgIcon viewBox="0 0 18 10" style={{ width: width, height: height, fill: `none`, ...style }}>
      <g>
        <path d="M15.033 3.14307L16.9142 6.77599" stroke={mainColor} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.1593 5.16211L11.7461 8.8719" stroke={mainColor} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.83342 5.1604L6.24661 8.87074" stroke={mainColor} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.96364 3.13989L1.07333 6.79037" stroke={mainColor} strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M1.08243 1.08057C2.46903 2.99417 5.01101 5.41389 9 5.41389C12.989 5.41389 15.531 2.99419 16.9176 1.08059"
          stroke={mainColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
